import { weights } from '../context/CerebroThemeProvider';
import { Link, LinkProps, styled } from '@mui/material';

type CerebroLinkButtonProps = LinkProps & { wide?: boolean };

const Input: React.FC<CerebroLinkButtonProps> = props => <Link {...props} />;

export const CerebroLinkButton = styled(Input, {
	shouldForwardProp: prop => prop !== 'wide',
})(({ wide = false, theme }) => ({
	backgroundColor: theme.palette.common.white,

	border: `1px solid ${theme.palette.gray.dark}`,

	borderRadius: 100,
	color: theme.palette.gray.dark,
	fontWeight: weights.semibold,
	fontSize: 16,
	lineHeight: '18px',
	textTransform: 'none',
	textDecoration: 'none',

	boxShadow: theme.shadows[3],

	padding: wide ? theme.spacing(1.5, 6) : theme.spacing(1.5, 3),

	'&:hover': {
		backgroundColor: theme.palette.common.white,
		boxShadow: theme.solidShadow(theme.palette.primary.main),
		borderColor: theme.palette.primary.main,
	},
}));
